import apiRequestType from "../../apiRequestType";
import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";

const getAADApplicationReportReportCSV = (
    userId = 0, 
    usergroupId, 
    fromDate, 
    toDate
) => {
        let baseUrl = apiConstants.BASE_URL_1;

        let reportUrlPart = apiConstants.REPORT.ACCESS_REPORT.GET_AAD_APPLICATION_ACCESS_REPORT_CSV(
        fromDate,
        toDate,
        userId,
        usergroupId
        );

        let url = encodeURIComponent(baseUrl + reportUrlPart);

        let apiRequestUrl = apiConstants.REPORT.ACCESS_REPORT.GET_AAD_USER_ACCESS_DETAIL_REPORT_CSV(url) + "&template=ApplicationAccessReport&isAADTenant=true";

        return apiRequestType(apiTypes.GET, apiRequestUrl);
}

export default getAADApplicationReportReportCSV